var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "step_1" } }, [
    _c("img", {
      staticStyle: { "max-width": "500px" },
      attrs: { src: require("../img/band-size.svg") },
    }),
    _vm._v(" "),
    _c("h2", [_vm._v("What's your band size?")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.lazy",
            value: _vm.$root.underbust_size,
            expression: "$root.underbust_size",
            modifiers: { lazy: true },
          },
        ],
        staticClass: "form-control",
        attrs: {
          placeholder: "put your inch measurement in here",
          type: "number",
          min: "25",
          max: "54",
          step: "0.5",
          required: "",
        },
        domProps: { value: _vm.$root.underbust_size },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.$root, "underbust_size", $event.target.value)
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n    To find your band size, grab a flexible measuring tape.\n    "
      ),
      _c("br"),
      _vm._v("\n    If you don't have one, download and print one\n    "),
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://cdn.shopify.com/s/files/1/0088/8461/7274/files/printable-measuring-tape.pdf?12401468153346143080",
          },
        },
        [_vm._v("HERE")]
      ),
      _vm._v(".\n  "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n    Measure the snug measurement at the base of your breasts.\n    "
      ),
      _c("br"),
      _vm._v(
        '\n    Round up to the nearest half inch; i.e. if you measure 32 1/4 inch, round up to 32.5" inches.\n  '
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }